import {
    tableState,
    tableMutations,
    tableActions,
    tableGetters
} from "@tt/vue-components";

import orderReferenceFilter from "@/store/modules/rmaOrdersOverview/filter/orderReferenceFilter";
import rmaReferenceFilter from "@/store/modules/rmaOrdersOverview/filter/rmaReferenceFilter";
import statusFilter from "@/store/modules/rmaOrdersOverview/filter/statusFilter";
import orderService from "@/services/OrderService";

const rmaOrdersOverview = {
    requestController: null,
    namespaced: true,
    state: {
        ...tableState,
        item: null,
        sorting: { sortBy: ["order.orderDt"], sortDesc: [true] },
        pagination: { itemsPerPage: 25, itemsPage: 1 },
        filters: [],
        defaultFilters: []
    },
    modules: {
        orderReferenceFilter,
        rmaReferenceFilter,
        statusFilter
    },
    mutations: {
        ...tableMutations,
        SET_ITEM(state, item) {
            state.item = item;
        }
    },
    actions: {
        ...tableActions,
        fetchItems(context, refresh = false) {
            if (refresh || context.state.items.length === 0) {
                context.commit("SET_LOADING", true);
                const params = { pagination: context.state.pagination, sorting: context.state.sorting, search: context.state.search };

                orderService.orderRmas.list(params)
                    .then(json => {
                        if (json) {
                            context.commit("SET_ITEMS", json);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        context.commit("SET_LOADING", false);
                    });
            }
        },
        fetchItem(context, id) {
            context.commit("SET_LOADING", true);
            orderService.orderRmas.get(id)
                .then(json => {
                    if (json) {
                        context.commit("SET_ITEM", json);
                    }
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    context.commit("SET_LOADING", false);
                });
        },
        search(context) {
            const params = [];
            const defaultParams = [];

            if (context.state.defaultFilters.length || context.state.filters.length) {
                context.state.defaultFilters.forEach(filter => {
                    let filterParams = context.getters[filter.name + "/toParams"];
                    if (filterParams !== undefined && filterParams.length > 0) {
                        for (let i = 0; i < filterParams.length; i++) {
                            defaultParams.push(JSON.parse(JSON.stringify(filterParams[i])));
                        }
                    }
                });
                context.state.filters.forEach(filter => {
                    let filterParams = context.getters[filter.name + "/toParams"];
                    if (filterParams !== undefined && filterParams.length > 0) {
                        for (let i = 0; i < filterParams.length; i++) {
                            params.push(JSON.parse(JSON.stringify(filterParams[i])));
                        }
                    }
                });
            }
            const allParams = [...defaultParams, ...params]
            if (allParams.length) {
                context.commit("SET_SEARCH", allParams.filter(param => {
                    return param.value !== undefined && param.value !== null && param.value !== "" && param.value !== []
                }));
            }
            context.dispatch("fetchItems", true);
        },
        selectItem(context, item) {
            context.commit("SET_ITEM", item);
            if (item) {
                context.dispatch("ordersOverview/order/fetchOrder", item.order.id, {root: true});
            }

            if (item !== null && item !== undefined) {
                context.dispatch("ordersOverview/shipments/fetchItems", item.order.id, {root: true});
            } else {
                context.dispatch("ordersOverview/shipments/resetItems", null, {root: true});
            }
        },
        edit({commit}, item) {
            return new Promise((resolve, reject) => {
                orderService.orderRmas.patch(item['id'], item)
                    .then((data) => {
                        commit("EDIT_ITEM", data);
                        commit("SET_ITEM", data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        editItem({state,commit}, item) {
            return new Promise((resolve, reject) => {
                orderService.orderRmaItems.patch(item['id'], item)
                    .then((data) => {
                        let updatedItem = state.item;

                        if (updatedItem && updatedItem.rmaItems) {
                            const index = updatedItem.rmaItems.findIndex(rmaItem => rmaItem['@id'] === data['@id']);
                            if (index !== -1) {
                                updatedItem.rmaItems[index] = data;
                            }
                        }

                        commit("EDIT_ITEM", updatedItem);
                        commit("SET_ITEM", updatedItem);
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        },
        returnAll(_, data ) {
            return new Promise((resolve, reject) => {
                orderService.orderRmas.returnAll(data)
                    .then(() => {
                        resolve();
                    })
                    .catch(err => {
                        reject(err["hydra:description"]);
                    });
            });
        }
    },
    getters: {
        ...tableGetters
    }
};

export default rmaOrdersOverview;
